<app-slide-in [isVisible]="(cart.openMiniCart$ | async)!" *transloco="let t">
  <div class="mini-cart-header">
    <span>{{ t('Your cart') }}</span>
    <button app-button="icon-button" (click)="onClose()" title="{{ t('Close cart') }}">
      <svg-icon key="close" size="sm"></svg-icon>
    </button>
  </div>
  <div class="mini-cart-items">
    <div class="mini-cart-info">
      <svg-icon key="basket"></svg-icon>
      <span>
        {{
          t(
            "Don't delay your purchase; adding items to the cart does not imply their reservation."
          )
        }}
      </span>
    </div>
    @for (product of cartData.lineItems; track product.id) {
      <div class="mini-cart-item">
        @if (product.image; as img) {
          <img [ngSrc]="img.url" width="72" height="72" [alt]="img.alt" />
        }
        <div class="mini-cart-details">
          <span class="title">{{ product.name }}</span>
          @if (product.price.current >= product.price.original) {
            <app-price
              [priceValue]="{
                regularPrice: product.price.current
              }"
            >
            </app-price>
          } @else {
            <app-price
              [priceValue]="{
                regularPrice: product.price.original,
                omnibusPrice: product.price.original,
                promoPrice: product.price.current
              }"
            >
            </app-price>
          }
          <button (click)="removeItem(product)">
            <span>{{ t('Remove') }}</span>
          </button>
        </div>
      </div>
    }
  </div>
  <div class="mini-cart-footer">
    <div class="mini-cart-totals">
      <span>{{ t('Cart') }} ({{ t('Quantity') }}: {{ cartData.itemCount }})</span>
      <app-price
        [priceValue]="{
          regularPrice: cartData.totalAmount
        }"
      >
      </app-price>
    </div>
    <div class="actions">
      <button app-button="primary-stroked" (click)="onClose()">
        {{ t('Continue shopping') }}
      </button>
      <a app-button [routerLink]="'/cart' | translateRoute | addLocale">
        {{ t('Go to cart') }}
      </a>
    </div>
  </div>
</app-slide-in>
@if ((cart.openMiniCart$ | async)!) {
  <div class="backdrop" (click)="onClose()"></div>
}
